import type { AnyAction } from 'redux';

import {
  PRODUCT_SET_INIT,
  type productSetStatuses,
} from 'src/app/shared/constants/productSetStatus';

export type ProductSetStatus = (typeof productSetStatuses)[number];

const defaultState = PRODUCT_SET_INIT;

const RESET = 'session/productSetStatus/RESET';
const UPDATE = 'session/productSetStatus/UPDATE';

export const actionResetProductSetStatus = () => ({
  type: RESET,
});

export const actionUpdateProductSetStatus = (value: ProductSetStatus) => ({
  type: UPDATE,
  value,
});

export default (state: State = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
